module.exports = __webpack_public_path__ + "img/7_windAndRain_xxh.5efbf619.png";